import { ContentPlacement } from '@candu-ai/placement/types';

import { SET_PLACEMENTS } from './constants';

export const setPlacements = (placements?: ContentPlacement[]) => {
  return {
    type: SET_PLACEMENTS,
    placements,
  };
};
